import { render, staticRenderFns } from "./SLTransactionsN.vue?vue&type=template&id=90996fba&"
import script from "./SLTransactionsN.vue?vue&type=script&lang=js&"
export * from "./SLTransactionsN.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports